import { render } from "./ProposalClient.vue?vue&type=template&id=2354ddf9&scoped=true&ts=true"
import script from "./ProposalClient.vue?vue&type=script&lang=ts"
export * from "./ProposalClient.vue?vue&type=script&lang=ts"

import "./ProposalClient.vue?vue&type=style&index=0&id=2354ddf9&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2354ddf9"]])

export default __exports__